import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { ProductSectorAggregate } from 'api'
import { SelectboxProps, Selectbox } from 'view/components/options'
import { Field } from 'view/components/inputs'
import { Locale, Translation } from 'locale'
import { createProductSectorAggregateGetterSelector } from 'selectors/fatFingerSelectors'
import { ProductSectorAggregateHelper } from 'model'
import { allKnownSortedProductSectorIdsSelector } from 'selectors/productSelectors'

interface AllFatFingerSectorSelectboxProps extends SelectboxProps<ProductSectorAggregate, string> {}

const fatFingerSectorMapStateToProps = createStructuredSelector({
  optionKeys: allKnownSortedProductSectorIdsSelector,
  getOption: createProductSectorAggregateGetterSelector
})

export const AllFatFingerSectorSelectbox = connect(fatFingerSectorMapStateToProps, null, null, { forwardRef: true })(
  Selectbox as React.ComponentType<AllFatFingerSectorSelectboxProps>
)

AllFatFingerSectorSelectbox.defaultProps = {
  getOptionText: ProductSectorAggregateHelper.getName,
  noItemsText: Locale.translate(Translation.SC_N_PRODUCT_SECTORS, { count: 0 })
}

export const AllFatFingerSectorSelectboxField = Field(AllFatFingerSectorSelectbox)
